"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--smar--ursa-icons--meterFillColor, #ADC6FA)",
  d: "M10 6.35a7.3 7.3 0 0 0-7.3 7.3h3.823c0-1.842 1.493-3.356 3.336-3.356 1.842 0 3.336 1.514 3.336 3.356H17.3a7.3 7.3 0 0 0-7.3-7.3Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.437 12.95h2.446a4.068 4.068 0 0 1 1.278-2.313L5.82 8.543a6.59 6.59 0 0 0-2.382 4.407ZM6.99 7.775 8.346 9.89a4.004 4.004 0 0 1 3.246.098l1.418-2.213A6.572 6.572 0 0 0 10 7.05a6.572 6.572 0 0 0-3.01.725Zm7.19.768-1.45 2.262a3.8 3.8 0 0 1 .297.338l.955-.521a.7.7 0 1 1 .67 1.229l-.962.525c.062.186.11.378.144.574h2.73a6.59 6.59 0 0 0-2.383-4.407Zm-1.75 4.52c.042.19.065.386.065.587a.7.7 0 0 0 .7.7H17.3a.7.7 0 0 0 .7-.7 8 8 0 0 0-16 0 .7.7 0 0 0 .7.7h3.823a.7.7 0 0 0 .7-.7c0-1.461 1.185-2.655 2.636-2.655.751 0 1.432.32 1.913.832l-2.107 1.15a.7.7 0 0 0 .67 1.229l2.095-1.143Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MeterThreeIcon20.js.map